import { RadarPage } from '@backstage/plugin-tech-radar';
import { Paper } from '@material-ui/core';
import React from 'react';
import { useParams } from 'react-router';
import { useGetAPI } from '../../Utils/useGetAPI';

export const TechWrapperRadar = () => {
  const { name } = useParams();

  const url = useGetAPI();

  const fullUrl = `${url}/v1/api/techradars/data/${name}`;

  return (
    <Paper>
      <RadarPage id={fullUrl} width={1500} height={800} />
    </Paper>
  );
};
